export default __webpack_public_path__ + "static/backdfund-a392b1a9dad47481f67c1bc079eb6d58.jpg";